// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ae8f8027","404":"fe7c7cf0","787":"76aeba29"}[chunkId] + ".chunk.js";
};